// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { twoSquaresInBrackets } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-two-squares-in-brackets': IconTwoSquaresInBrackets;
    }
}

/**
 * The icon component for the 'twoSquaresInBrackets' icon
 */
export class IconTwoSquaresInBrackets extends Icon {
    public constructor() {
        super(twoSquaresInBrackets);
    }
}

registerIcon('icon-two-squares-in-brackets', IconTwoSquaresInBrackets);
export const iconTwoSquaresInBracketsTag = 'nimble-icon-two-squares-in-brackets';
